import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/* PWA / Offline — register service worker with auto-versioned URL.
 * REACT_APP_BUILD_HASH is injected at build time (set in CI / Vercel / Netlify).
 * In dev mode, falls back to the current date so each fresh load installs a new SW. */
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    const buildHash =
      process.env.REACT_APP_BUILD_HASH ||
      (process.env.NODE_ENV === "production" ? "prod" : `dev-${new Date().toISOString().slice(0, 10)}`);
    const swUrl = `/sw.js?v=${encodeURIComponent(buildHash)}`;
    navigator.serviceWorker
      .register(swUrl, { scope: "/" })
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[SW] registered v=", buildHash, reg.scope);
        // Force update check on every load
        reg.update?.().catch(() => {});
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[SW] registration failed", err);
      });
  });
}
